import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyOtp, sendOtp } from "../../../services/otpService";
import { logo } from "../../imagepath";
import { getUserDetails } from "../../../services/userService";
import { AppContext } from "../../../services/AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Spinner ve animasyon için stil ekle
const spinnerStyle = `
@keyframes fadeSlideIn {
  0% { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
}
.otp-fade-slide {
  animation: fadeSlideIn 0.4s cubic-bezier(.4,0,.2,1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.otp-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #b3e0f7;
  border-top: 3px solid #0dcaf0;
  border-radius: 50%;
  animation: otp-spin 0.7s linear infinite;
}
@keyframes otp-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

const OtpVerify = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("temptoken");
  const { setAuth } = useContext(AppContext);
  const location = useLocation();
  const email = location.state?.email || "example@email.com";

  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [countdown]);

  // Otomatik odak ilk inputa
  useEffect(() => {
    if (inputRefs.current[0]) inputRefs.current[0].focus();
  }, []);

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    if (!val) {
      setOtp((prev) => prev.map((d, i) => (i === idx ? "" : d)));
      return;
    }
    let arr = [...otp];
    arr[idx] = val[val.length - 1];
    setOtp(arr);
    if (val && idx < 5) {
      inputRefs.current[idx + 1].focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    if (paste.length === 6) {
      setOtp(paste.split(""));
      inputRefs.current[5].focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !otp[idx] && idx > 0) {
      inputRefs.current[idx - 1].focus();
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const code = otp.join("");
      const response = await verifyOtp(token, code);
      toast.success(response.message || "Doğrulama başarılı!");
      const detail = await getUserDetails(token);
      const authData = {
        token: token,
        id: detail.data.id,
        title: detail.data.title,
        name: detail.data.name,
        surname: detail.data.surname,
        email: detail.data.email,
        telephone: detail.data.telephone,
        address: detail.data.address,
        regdate: detail.data.regdate,
        tc: detail.data.tc,
        regstatus: detail.data.regstatus,
        mobileuser: detail.data.mobileuser,
        updatedate: detail.data.updatedate,
        rolename: detail.data.rolename
      };
      setAuth(authData);
      sessionStorage.setItem('auth', JSON.stringify(authData));
      const encodedAuthData = encodeURIComponent(JSON.stringify(authData));
      const redirectPath = location.state?.from || "/profile";
      const redirectState = location.state?.autoDownload ? { autoDownload: true } : undefined;
      navigate(redirectPath, { state: redirectState });
    } catch (error) {
      toast.error(error.response?.data?.message || "Doğrulama başarısız.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      setCountdown(60);
      setCanResend(false);
      const response = await sendOtp(token);
      toast.success(response.message || "Kod yeniden gönderildi!");
    } catch (error) {
      toast.error("Kod gönderilemedi.");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Stil ekle */}
      <style>{spinnerStyle}</style>
      <div className="flex-grow-1">
        <div className="container-fluid">
          <div className="row min-vh-100 justify-content-center align-items-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
              <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                <img src={logo} alt="Logo" className="img-fluid" style={{ maxHeight: 50 }} />
              </div>
              <div className="bg-light rounded-4 shadow-sm p-4">
                <h4 className="fw-semibold mb-2 text-center text-darkfume">E-posta Doğrulama</h4>
                <p className="text-center text-secondary mb-1">Doğrulama kodunu e-posta adresinize gönderdik</p>
                <p className="text-center text-secondary mb-4" style={{ fontSize: 15 }}>{email}</p>
                <form onSubmit={handleVerify}>
                  <div className="d-flex justify-content-center mb-3" onPaste={handlePaste}>
                    {otp.map((data, idx) => (
                      <input
                        key={idx}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        className="otp-input mx-1 text-center"
                        style={{ width: 48, height: 56, fontSize: 28, borderRadius: 12, border: '2px solid #bbb', background: '#fff', outline: 'none', boxShadow: 'none', fontWeight: 500 }}
                        value={data}
                        ref={el => inputRefs.current[idx] = el}
                        onChange={e => handleChange(e, idx)}
                        onKeyDown={e => handleKeyDown(e, idx)}
                        autoFocus={idx === 0}
                      />
                    ))}
                  </div>
                  <div className="text-center mb-3">
                    {!canResend ? (
                      <p className="text-darkfume fw-semibold mb-0" style={{ fontSize: 15 }}>Kod gelmedi mi? <b>{countdown}</b> saniye sonra yeniden gönder.</p>
                    ) : (
                      <p className="mb-0" style={{ fontSize: 15 }}>
                        Kod gelmedi mi?{' '}
                        <button
                          type="button"
                          className="btn btn-link p-0 m-0 align-baseline"
                          onClick={handleResend}
                        >
                          Yeniden gönder
                        </button>
                      </p>
                    )}
                  </div>
                  <div className="d-grid mb-2">
                    <button className="btn-primary text-sm" type="submit" disabled={loading || otp.some(x => !x)} style={{ minHeight: 40, fontWeight: 500, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span className="otp-fade-slide" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {loading ? (
                          <span className="otp-spinner"></span>
                        ) : (
                          "Devam Et"
                        )}
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default OtpVerify;
